import React, { Fragment, useContext, useEffect, useState } from 'react';
import { Col, Card, CardHeader, Table, Form, FormGroup, Label, Input, ModalFooter, Row } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import Pagination from '../../Components/Pagination/Pagination';
import Empty from '../../Components/Empty/Index';
import moment from 'moment';
import { useNavigate } from 'react-router';
import CustomizerContext from '../../_helper/Customizer';
import NoImage from '../../assets/images/noimage.png';
import { getTransaction } from '../../store/transactionSlice';

const TransactionTable = () => {
  const storeVar = useSelector(state => state.transactions)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { layoutURL } = useContext(CustomizerContext);
  const [typingTimer, setTypingTimer] = useState(null);
  const typingDelay = 800;
  const [formVar, setFormVar] = useState({
    keyword: '',
    limit: 30,
    offset: 0,
    currentPage: 1,
    status: 'active',
    type: '',
    fromDate: moment().subtract(15, 'days').format('YYYY-MM-DD'),
    toDate: moment().format('YYYY-MM-DD'),
  });

  useEffect(() => {
    dispatch(getTransaction(formVar.limit, formVar.offset, formVar.keyword, formVar.fromDate, formVar.toDate, formVar.type))
  }, []);

  const pageChange = (page) => {
    const offset = formVar.limit * (page - 1)
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      currentPage: page,
      offset: offset
    }))
    dispatch(getTransaction(formVar.limit, offset, formVar.keyword, formVar.fromDate, formVar.toDate, formVar.type))
  };
  const searchState = (e) => {
    const value = e.target.value;
    setFormVar((prevFormVar) => ({ ...prevFormVar, keyword: value, offset: 0, currentPage: 1 }))
    searchWithDelay(value)
  }
  const searchWithDelay = (keyword) => {
    clearTimeout(typingTimer);
    const timer = setTimeout(() => {
      dispatch(getTransaction(formVar.limit, 0, keyword, formVar.fromDate, formVar.toDate, formVar.type))
    }, typingDelay);
    setTypingTimer(timer);
  };


  const handleDateChange = (e) => {
    const value = e.target.value;
    setFormVar((prevFormVar) => ({ ...prevFormVar, fromDate: value, offset: 0, currentPage: 1 }));
    dispatch(getTransaction(formVar.limit, 0, formVar.keyword, value, formVar.toDate, formVar.type));
  }
  const handleDateendChange = (e) => {
    const value = e.target.value;
    setFormVar((prevFormVar) => ({ ...prevFormVar, toDate: value, offset: 0, currentPage: 1 }))
    dispatch(getTransaction(formVar.limit, 0, formVar.keyword, formVar.fromDate, value, formVar.type));
  }
  const handlePaymentChange = (e) => {
    const value = e.target.value;
    setFormVar((prevFormVar) => ({ ...prevFormVar, type: value, offset: 0, currentPage: 1 }))
    dispatch(getTransaction(formVar.limit, 0, formVar.keyword, formVar.fromDate, formVar.toDate, value));
  };
  const getDateTime = (date) => {
    if (date) {
      return moment(date).format("DD MMM YYYY hh:mm A");
    }
  };
  const onNavigate = (data) => {
    navigate(`/transaction/details/` + layoutURL + '?id=' + data._id)
  }





  return (
    <Fragment>
      <Col sm='12'>
        <Card>
          <CardHeader>
            <Row>
              <Col md="3">
                <Label className="col-form-label" htmlFor="recipient-name">Search</Label>
              </Col>
              <Col md="3">
                <Label className="col-form-label" htmlFor="recipient-name">From</Label>
              </Col>
              <Col md="3">
                <Label className="col-form-label" htmlFor="recipient-name">To</Label>
              </Col>
              <Col md="3">
                <Label className="col-form-label" htmlFor="recipient-name">Purchase Type</Label>
              </Col>
            </Row>
            <Row>
              <Col md="3">
                <Input className="form-control" placeholder='Search....' type="text" id="yourInputId"
                  value={formVar.keyword} onChange={(e) => searchState(e)}
                />
              </Col>
              <Col md="3">
                <Input className="form-control form-control-inverse btn-square" max={moment().format('YYYY-MM-DD')} name="select" type="DATE"
                  value={formVar.fromDate} onChange={handleDateChange}>
                </Input>
              </Col>
              <Col md="3">
                <Input className="form-control form-control-inverse btn-square" max={moment().format('YYYY-MM-DD')} name="select" type="DATE"
                  value={formVar.toDate} onChange={handleDateendChange}>
                </Input>
              </Col>
              <Col md="3">
                <Input className="form-control form-control-inverse btn-square" name="select" type="select"
                  value={formVar.type} onChange={handlePaymentChange}>
                  <option value=''>All</option>
                  <option value='class'>Class</option>
                  <option value='subscription'>Subscription</option>
                </Input>
              </Col>
            </Row>

          </CardHeader>
          <div className='table-responsive'>
            <Table hover={true} className='table-border-horizontal table-light'>
              <thead>
                <tr>
                  <th scope='col'>Sl.No</th>
                  <th scope='col'>Name</th>
                  <th scope='col'>Amount</th>
                  <th scope='col'>Transaction Id</th>
                  <th scope='col'>Transaction Time</th>
                  <th scope='col'>Status</th>
                  <th scope='col'>Action</th>
                </tr>
              </thead>
              <tbody>
                {storeVar.transactionData?.map((item, index) => (
                  <tr key={index}>
                    <th scope='row'>{index + 1}</th>
                    <td >{item.userId?.name}</td>
                    <td >₹{new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format((item.amount || 0))}</td>
                    <td >{item.transactionId}</td>
                    <td >{getDateTime(item.createdAt)}</td>

                    <td>
                      {
                        item.type === 'class' && <>
                          <span className={`font-success rounded-1 p-1 me-2 d-flex align-items-center`}>
                            <i className="fa fa-check-circle-o fa-lg" aria-hidden="true"></i>
                            &nbsp; <span>Class</span>
                          </span>
                        </>
                      }
                      {
                        item.type === 'subscription' && <>
                          <span className={`font-success rounded-1 p-1 me-2 d-flex align-items-center`}>
                            <i className="fa fa-clock-o fa-lg" aria-hidden="true"></i>
                            &nbsp; <span>Subscription</span>
                          </span>
                        </>
                      }

                    </td>
                    <td>
                      <div className='d-flex gap-2 align-items-center'>
                        <div className='cursor-pointer bg-light-primary font-info action-icon'>
                          <i className="fa fa-info-circle fa-lg" onClick={(e) => onNavigate(item)}></i>
                          <div className="tooltipCustom">More Details</div>
                        </div>

                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          {
            storeVar.totalTransaction <= 0 && (
              <Empty />
            )
          }
        </Card>
        {
          storeVar.totalTransaction > 0 &&
          <Pagination currentPage={formVar.currentPage} totalItem={storeVar.totalTransaction}
            itemsPerPage={formVar.limit} showEllipsisAfter={true} visiblePageCount={3} onPageChange={pageChange} />
        }
      </Col>
    </Fragment>
  );
};

export default TransactionTable;
